import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
} from '@angular/core';
import { DialogBase, DialogOptions } from '@context/frontend/common';
import { Organization } from '@context/shared/types/organization';
import { TranslocoModule } from '@jsverse/transloco';
import { OrganizationSelectorComponent } from '../../components';
import { AuthService } from '../../services/auth.service';

@Component({
	standalone: true,
	imports: [TranslocoModule, OrganizationSelectorComponent],
	selector: 'ctx-organization-selector-dialog',
	templateUrl: 'organization-selector-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationSelectorDialogComponent extends DialogBase<
	(Organization & { id: string }) | null
> {
	static override readonly DialogOptions = {
		label: 'select-organization.title',
		size: 's',
	} as DialogOptions;

	private readonly authService = inject(AuthService);

	readonly busy = signal(false);

	onOrganizationSelected(org: Organization & { id: string }): void {
		this.busy.set(true);
		this.authService
			.selectOrganization(org.id)
			.then(() => {
				this.busy.set(false);
				this.onDismiss(org);
			})
			.catch((err) => {
				console.error('Error selecting organization', err);
				this.busy.set(false);
			});
	}
}
